import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a04d954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6 col-12\" data-v-0a04d954><h3 class=\"mt-md\" data-v-0a04d954><strong data-v-0a04d954>Nie wiesz ile powinna kosztować naprawa?</strong></h3><div class=\"index-img mt-lg d-lg-flex d-none\" data-v-0a04d954><img src=\"/static/images/index-page/expense.png\" data-v-0a04d954></div><p class=\"mt-sm little-gray description-text\" data-v-0a04d954> Ile powinienem zapłacić za naprawę sprzęgła? </p><p class=\"little-gray description-text\" data-v-0a04d954>A za wymianę alternatora?</p><p class=\"description-text\" data-v-0a04d954> Automatycznie wyliczamy ile powinieneś zapłacić za naprawę mechaniczną </p><p class=\"description-text\" data-v-0a04d954><strong data-v-0a04d954>Dowiedz się ile kosztuje twoja naprawa</strong></p></div>", 1)
const _hoisted_3 = { class: "col-lg-6 col-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center mt-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/images/index-page/estimate-costs.png",
    style: {"width":"100%","height":"auto","max-width":"500px"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_zloty_icon = _resolveComponent("zloty-icon")!
  const _component_index_button = _resolveComponent("index-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_index_button, {
        text: "Sprawdź koszt",
        to: {
          name: _ctx.getSelectedCar?.typeId
            ? 'tec-estimate-list'
            : 'tec-estimate-list-no-car',
          params: { typeId: _ctx.getSelectedCar?.typeId },
        }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_zloty_icon)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}